<template>
  <div>
    <div class="mb-3">
      <v-statistics-widget/>
    </div>

    <div class="row">
      <div
        class="col-md-6 mb-3"
        v-if="choiceItems.length > 0 || loadingResearchItems"
      >
        <v-empty-state-widget
          v-if="loadingResearchItems"
        />
        <v-choice-chart-widget
          v-else-if="choiceItems.length > 0"
        />
      </div>
      <div class="col-md-6 mb-3">
        <v-empty-state-widget
          v-if="loadingResearchItems"
        />
        <v-bar-chart-widget
          v-else-if="numericItems.length > 0"
        />
      </div>
      <div
        class="mb-3"
        :class="openAnswerWidgetClass"
        v-if="textualItems.length > 0 || loadingResearchItems"
      >
        <v-empty-state-widget
          v-if="loading"
        />
        <v-open-answer-widget
          v-else-if="textualItems.length > 0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BarChartWidget from '@/organisation/components/research/widgets/BarChartWidget.vue';
import ChoiceChartWidget from '@/organisation/components/research/widgets/ChoiceChartWidget.vue';
import EmptyStateWidget from '@/organisation/components/research/widgets/EmptyStateWidget.vue';
import OpenAnswerWidget from '@/organisation/components/research/widgets/OpenAnswerWidget.vue';
import StatisticsWidget from '@/organisation/components/research/widgets/StatisticsWidget.vue';
import { mapGetters } from 'vuex';
import { isChoice } from '@/common/services/items';

export default {
  name: 'ResearchDashboardTab',
  components: {
    'v-bar-chart-widget': BarChartWidget,
    'v-choice-chart-widget': ChoiceChartWidget,
    'v-empty-state-widget': EmptyStateWidget,
    'v-open-answer-widget': OpenAnswerWidget,
    'v-statistics-widget': StatisticsWidget,
  },
  computed: {
    ...mapGetters('researches', [
      'loadingResearchItems',
      'loadingResearchReviewSessions',
      'loadingResearchStatistics',
      'researchItems',
    ]),
    loading() {
      return (
        this.loadingResearchItems
        || this.loadingResearchReviewSessions
        || this.loadingResearchStatistics
      );
    },
    choiceItems() {
      return this.researchItems.filter((researchItem) => isChoice(researchItem.item.render_type));
    },
    numericItems() {
      return this.researchItems.filter(
        (researchItem) => researchItem.item.is_numeric,
      );
    },
    openAnswerWidgetClass() {
      if (this.numericItems.length > 0 && this.choiceItems.length > 0) {
        return 'col-md-12';
      }
      return 'col-md-6';
    },
    textualItems() {
      return this.researchItems.filter(
        (researchItem) => researchItem.item.render_type === 'text',
      );
    },
  },
};
</script>
